(function () {
  var root = document.getElementById('pr-skin-finder');
  if (!root) return;

  var body = root.querySelector('[data-pr-sf-body]');
  var back = root.querySelector('[data-pr-sf-back]');
  var steps = root.querySelectorAll('[data-step]');
  var start = root.querySelector('[data-step="condition"]');
  var areaStep = root.querySelector('[data-step="area"]');
  var trail = [];
  var condition = null;

  function current() {
    for (var i = 0; i < steps.length; i++) if (!steps[i].hidden) return steps[i];
    return start;
  }

  function show(step) {
    steps.forEach(function (s) { s.hidden = s !== step; });
    body.scrollTop = 0;
    back.hidden = trail.length === 0;
  }

  function go(step) {
    trail.push(current());
    show(step);
  }

  function reset() {
    trail = [];
    condition = null;
    show(start);
  }

  function fillGroup(group) {
    if (group.dataset.filled) return;
    group.dataset.filled = '1';
    group.getAttribute('data-products').split(',').forEach(function (handle) {
      var tpl = handle && root.querySelector('template[data-pr-sf-card="' + handle + '"]');
      if (tpl) group.appendChild(tpl.content.cloneNode(true));
    });
  }

  function showResult(id, area) {
    var result = root.querySelector('[data-result="' + id + '"]');
    if (!result) return;
    result.setAttribute('data-area', area);
    var seen = {};
    result.querySelectorAll('[data-group]').forEach(function (group) {
      fillGroup(group);
      group.hidden = area !== 'both' && group.getAttribute('data-group') !== area;
      group.querySelectorAll('.pr-sf__card').forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        card.hidden = !group.hidden && seen[id];
        if (!group.hidden) seen[id] = true;
      });
      if (!group.hidden && !group.querySelector('.pr-sf__card:not([hidden])')) group.hidden = true;
    });
    var err = result.querySelector('[data-pr-sf-error]');
    if (err) err.hidden = true;
    var addAll = result.querySelector('[data-pr-sf-add-all]');
    if (addAll) addAll.hidden = result.querySelectorAll('[data-group]:not([hidden]) .pr-sf__card[data-available="true"]:not([hidden])').length < 2;
    go(result);
  }

  function addToCart(ids, button) {
    var cart = document.querySelector('cart-drawer');
    var payload = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    if (cart && cart.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    var err = button.closest('[data-step]').querySelector('[data-pr-sf-error]');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (err) {
            err.textContent = res.description || res.message || 'Não foi possível adicionar ao carrinho.';
            err.hidden = false;
          }
          return;
        }
        root.close();
        if (cart && cart.renderContents && res.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { button.disabled = false; });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-condition], [data-area], [data-pr-sf-back], [data-pr-sf-add], [data-pr-sf-add-all]');
    if (!t) return;

    if (t.hasAttribute('data-condition')) {
      condition = t.getAttribute('data-condition');
      var face = t.getAttribute('data-face') === 'true';
      var bodyArea = t.getAttribute('data-body') === 'true';
      if (face && bodyArea) go(areaStep);
      else showResult(condition, face ? 'face' : 'body');
    } else if (t.hasAttribute('data-area')) {
      showResult(condition, t.getAttribute('data-area'));
    } else if (t.hasAttribute('data-pr-sf-back')) {
      show(trail.pop() || start);
    } else if (t.hasAttribute('data-pr-sf-add')) {
      addToCart([t.closest('.pr-sf__card').getAttribute('data-variant-id')], t);
    } else if (t.hasAttribute('data-pr-sf-add-all')) {
      var ids = [];
      t.closest('[data-step]').querySelectorAll('[data-group]:not([hidden]) .pr-sf__card[data-available="true"]:not([hidden])').forEach(function (card) {
        ids.push(card.getAttribute('data-variant-id'));
      });
      if (ids.length) addToCart(ids, t);
    }
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pr-sf-open]');
    if (!trigger || typeof root.open !== 'function') return;
    e.preventDefault();
    var menu = trigger.closest('header-drawer');
    if (menu && typeof menu.closeMenuDrawer === 'function') menu.closeMenuDrawer(e);
    reset();
    root.open(trigger);
    var pre = trigger.getAttribute('data-pr-sf-condition');
    if (pre) {
      var opt = root.querySelector('[data-condition="' + pre + '"]');
      if (opt) setTimeout(function () { opt.click(); }, 60);
    }
  });
})();
